var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCenterWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 416,
    height: 433,
    viewBox: "0 0 416 433",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.628906 337.695L38.1488 55.5321C47.1277 34.2465 55.1284 24.4931 81.672 13.5078C165.555 5.63801 233.5 3.95855 347.313 0C376.646 8.8112 394.238 13.5281 408.846 55.5321C412.329 169.345 415.996 250.574 415.599 324.938C414.401 357.978 407.047 371.127 381.081 384.222C223.726 413.091 137.616 428.655 63.6624 433C19.066 419.114 0.956105 399.961 0.628906 337.695Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterWhite);
export default __webpack_public_path__ + "static/media/CenterWhite.1e10524ba3f57d88f30af006c6d37213.svg";
export { ForwardRef as ReactComponent };